import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

import Footer from "../../components/Footer/Footer.jsx";

import bgImage from "../../assets/img/full-screen-image-3.jpg";
import LoginPage from "../../views/Pages/LoginPage.jsx";
import Sidebar from "../../components/Sidebar/Sidebar.jsx";

class Pages extends Component {

  render() {
    return (
      <div>
        <div className="wrapper wrapper-full-page">
          <div
            className={"full-page login-page"}
            data-color="black"
            data-image={bgImage}
          >
      <Sidebar />
            <div className="content">
              <LoginPage />
            </div>
            <Footer transparent />
            <div
              className="full-page-background"
              style={{ backgroundImage: "url(" + bgImage + ")" }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Pages;
